export default {
  'pages.memberList.title': '会员列表',
  'pages.memberList.create': '创建会员',
  'pages.memberList.exportCustomer': '导出顾客',
  'pages.memberList.exportRetailCustomerTitle': '导出普通顾客',
  'pages.memberList.create.title': '创建会员',
  'pages.memberList.firstName': '名',
  'pages.memberList.firstName.required': '请输入名',
  'pages.memberList.middleName': '中间名',
  'pages.memberList.lastName': '姓',
  'pages.memberList.lastName.required': '请输入姓',
  'pages.memberList.allowNameEdit': '允许自行修改姓名',
  'pages.memberList.allowNameEdit.help': '此权限用于区分普通顾客和 Staff & Trade Members。',
  'pages.memberList.memberId': '会员ID',
  'pages.memberList.name': '姓名',
  'pages.memberList.phone': '手机号',
  'pages.memberList.phone.required': '请输入手机号',
  'pages.memberList.phone.invalid': '请输入有效的手机号',
  'pages.memberList.email': '邮箱',
  'pages.memberList.email.invalid': '请输入有效的邮箱地址',
  'pages.memberList.email.maxLength': '邮箱不能超过255个字符',
  'pages.memberList.birthday': '生日',
  'pages.memberList.notes': '备注',
  'pages.memberList.level': '会员等级',
  'pages.memberList.level.required': '请选择会员等级',
  'pages.memberList.level.discount': '折扣',
  'pages.memberList.customizeDiscount': '自定义折扣',
  'pages.memberList.customizeDiscount.required': '请输入自定义折扣',
  'pages.memberList.customizeDiscount.invalid': '自定义折扣必须在 0 到 100 之间',
  'pages.memberList.points': '积分',
  'pages.memberList.status': '状态',
  'pages.memberList.status.active': '激活',
  'pages.memberList.status.inactive': '未激活',
  'pages.memberList.actions': '操作',
  'pages.memberList.actions.details': '详情',
  'pages.memberList.create.success': '会员创建成功',
  'pages.memberList.headoffice.error': '获取总部信息失败',
  'pages.memberList.level.fetch.error': '获取会员等级失败',
  'pages.memberList.search.info': '搜索信息',
  'pages.memberList.search.memberId.placeholder': '输入会员ID',
  'pages.memberList.search.info.placeholder': '输入搜索信息',
  'pages.memberList.search.level.placeholder': '选择会员等级',
  'pages.memberList.search.submit': '搜索',
  'pages.memberList.search.reset': '重置',
  'pages.memberList.search.refresh': '刷新',
  'pages.memberList.total': '总计',
  'pages.memberList.items': '项',
  'pages.memberList.pagination.total': '共 {total} 项',
  'pages.memberList.pagination.pageSize': '/页',
  'pages.memberList.pagination.jump': '跳至',
  'pages.memberList.pagination.page': '页',
  'pages.memberList.rewardEnabled': '启用积分奖励',
  'pages.memberList.hasExistingMemberId': '已有会员ID',
  'pages.memberList.existingMemberId': '会员ID',
  'pages.memberList.existingMemberId.required': '请输入会员ID',
  'pages.memberList.existingMemberId.invalid': '请输入有效的会员ID（允许字母和数字）',
  'pages.memberList.existingMemberId.maxLength': '会员ID最大长度为15位',
  'pages.memberList.existingMemberId.placeholder': '请输入已存在的会员ID',
  'pages.memberList.cardNumber': '卡号',
  'pages.memberList.cardNumber.invalid': '最多 20 位字母或数字',
  'pages.memberList.cardNumber.placeholder': '选填，最多 20 位字母或数字',
  'pages.memberList.cardNumber.help': '可在 Enrich POS 中像会员 ID 一样搜索，总部内不能重复。清空即删除卡号。',
  'pages.memberList.search.memberIdOrCard.placeholder': '输入会员ID或卡号',
};
